<block-ui>
	<div *ngIf="messages.length !== 0">
		<progress-log #progressLog [messages]="messages"></progress-log>
	</div>
	<div class="flex-direction-column flex-fill">
		<div class="flex-none">
			<mat-toolbar class="flex-direction-row flex-align-center mat-primary main-toolbar">
				<span [routerLink]="['/']" class="flex-direction-row flex-align-start-center"
					(click)="onLogoClick($event)" style="outline: none; cursor: pointer !important">
					<img src="../assets/amorph-pro-dark.png" class="cursor-pointer" />
				</span>
				<div class="flex-100"></div>
				<div *ngIf="globalSrv.debugMode" style="opacity: 0.5">[DEBUG]&nbsp;&nbsp;</div>
				<div class="flex-direction-row logo">
					<span style="font-weight: 100">{{ 'i18n.smart' | translate }}</span>
					<span style="font-weight: bold">{{ 'i18n.unifier' | translate }}</span>
				</div>
				<span class="spacer"></span>
				<button id="notifications_button" mat-icon-button (click)="notificationsMenuTrigger.openMenu()">
					<mat-icon #notificationsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="notificationsMenu"
						[matBadge]="non_read_notifications.length ? non_read_notifications.length : null"
						matBadgeColor="accent">notifications</mat-icon>
				</button>
				<button id="account_button" mat-icon-button (click)="userMenuTrigger.openMenu()">
					<mat-icon #userMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">account_circle</mat-icon>
				</button>
				<a id="help_button" mat-icon-button matTooltip="Help" href="{{ helpLink() }}" target="_blank"
					class="flex-align-center">
					<mat-icon>help_outline</mat-icon>
				</a>
			</mat-toolbar>
		</div>

		<div class="flex-auto flex-direction-row" style="height: calc(100vh - 65px);">
			<mat-sidenav-container class="flex-auto main-side-menu">
				<mat-sidenav #sidenav mode="side" id="drawer" [opened]="!isSidebarClosed">
					<div class="flex-auto flex-direction-row">

						<mat-nav-list style="width: max-content">
							<ng-container *ngFor="let item of menuItems; let i = index">
								<ng-container *ngIf="item.data.display">
									<div [ngSwitch]="item.path == 'SECTION'">
										<div *ngIf="item.data.menuitemid == 'smartunifierconfiguration'"
											class="custom-mat-nav-header">
											<ng-container *ngIf="!isSidebarCollapsed">
												<span mat-subheader *ngSwitchCase="true" mat-list-item
													class="header-content"><span [style.font-weight]="100">SMART</span>
													<span [style.font-weight]="400">UNIFIER</span> {{ item.data.title |
													translate }}</span>
											</ng-container>

											<button mat-icon-button *ngIf="i == 0" (click)="onSidebarCollapseToggle()"
												class="sidebar-toggle">
												<mat-icon *ngIf="!isSidebarCollapsed">keyboard_arrow_left</mat-icon>
												<mat-icon *ngIf="isSidebarCollapsed">keyboard_arrow_right</mat-icon>
											</button>
										</div>

										<mat-list-item id="{{ item.data.menuitemid }}_menuitem"
											class="menu_item custom-menu-item" *ngSwitchCase="false"
											[class.selected]="isItemActive(item)"
											matTooltip="{{ item.data.title | translate }}"
											[matTooltipPosition]="'right'" [matTooltipDisabled]="!isSidebarCollapsed"
											[routerLink]="[item.path]">
											<div class="mat-icon-text-wrapper">
												<mat-icon class="custom-mat-icon" *ngIf="!item.data.svgIcon">{{
													item.data.icon }}</mat-icon>
												<mat-icon class="custom-mat-icon" *ngIf="item.data.svgIcon"
													[svgIcon]="item.data.icon"></mat-icon>

												<ng-container *ngIf="!isSidebarCollapsed">
													<span class="custom-mat-nav-text">
														{{ item.data.title | translate }}
													</span>
												</ng-container>
											</div>
										</mat-list-item>
									</div>
								</ng-container>
							</ng-container>
						</mat-nav-list>
						<mat-nav-list style="width: max-content" class="dependencySideBar"
							*ngIf="globalSrv.uiPinnedArtifact && globalSrv.applicationConf.dependencyViewEnabled">
							<div class="custom-mat-nav-header">
								<ng-container *ngIf="!isDependencyTreeSidebarCollapsed">
									<span mat-subheader mat-list-item class="header-content"><span
											[style.font-weight]="100">Dependency Tree </span> </span>
								</ng-container>

								<button mat-icon-button (click)="onDependencySidebarCollapseToggle()"
									class="sidebar-toggle">
									<mat-icon *ngIf="!isDependencyTreeSidebarCollapsed">keyboard_arrow_left</mat-icon>
									<mat-icon *ngIf="isDependencyTreeSidebarCollapsed">keyboard_arrow_right</mat-icon>
								</button>
							</div>

							<div *ngIf="!isDependencyTreeSidebarCollapsed && dependencyTree != null">
								<button mat-icon-button (click)="clearPin()"  matTooltip="Abhängigkeitsbaum ausblenden">
									<mat-icon class="visibility_off"></mat-icon>
								</button>
								<!-- <div class="depencencytree-node">
									<div class="depencencytree-node">
										<span class="clickable-element">Instance</span>
										<span class="clickable-element">Instance</span>
										<span class="clickable-element">Instance</span>
									</div>
								</div>
								<div class="depencencytree-node">
									<span class="clickable-element root">Device Type</span>
									<div class="depencencytree-node">
										<span class="clickable-element">Mapping</span>
										<div class="depencencytree-node">
											<span class="clickable-element">IM</span>
											<span class="clickable-element">Channel</span>
										</div>
									</div>
									<div class="depencencytree-node">
										<span class="clickable-element">Mapping</span>
										<div class="depencencytree-node">
											<span class="clickable-element">IM</span>
											<span class="clickable-element">Channel</span>
										</div>
									</div>
								</div> -->
								<div class="depencencytree-node hidden">
									<ng-container *ngFor="let child of dependencyTree.dependants">
										<ng-container
											*ngTemplateOutlet="dependencyTreeNode; context: {$implicit: child, direction: 'dependants', dontGoInto: []}">
										</ng-container>
									</ng-container>
								</div>
								<ng-container
									*ngTemplateOutlet="dependencyTreeNode; context: {$implicit: dependencyTree, direction: 'dependencies', dontGoInto: []}">
								</ng-container>
							</div>

							<ng-template #dependencyTreeNode let-node let-direction="direction"
								let-dontGoInto="dontGoInto">
								<div class="depencencytree-node"
									[class.down]="node.identifier.id != globalSrv.uiPinnedArtifact && direction == 'dependencies'"
									[class.up]=" node.identifier.id != globalSrv.uiPinnedArtifact &&direction == 'dependants'">
									<div [matMenuTriggerFor]="dependencyTreeMenu" [matMenuTriggerData]="{node: node}"
										class="clickable-element flex flex-direction-row flex-align-items-center flex-justify-between"
										[class._selected]="currentLocation.indexOf(node.identifier.id) >= 0"
										matTooltipClass="multiline-tooltip"  [matTooltip]="getDependencyTreeTooltipText(node)">
										<!-- 
										(click)="gotoArtifact(node)"
										 -->
										<div class="translate">
											<mat-icon *ngIf="!dependencyTreeIconMap[node.nodeType].svg"
												class="custom-mat-icon img-icon ">{{
												dependencyTreeIconMap[node.nodeType].name }}</mat-icon>
										</div>
										<div class="translate">
											<mat-icon *ngIf="dependencyTreeIconMap[node.nodeType].svg"
												class="custom-mat-icon "
												[svgIcon]="dependencyTreeIconMap[node.nodeType].name"></mat-icon>
										</div>
										<span>{{node.externalIdentifier.name}}</span>
									</div>
									<ng-container
										*ngIf="direction == 'dependencies' && dontGoInto.indexOf(node.nodeType) < 0">
										<ng-container *ngFor="let child of node.dependencies">
											<ng-container
												*ngTemplateOutlet="dependencyTreeNode; context: {$implicit: child, direction: direction, dontGoInto: dontGoInto}">
											</ng-container>
										</ng-container>
									</ng-container>
									<ng-container
										*ngIf="direction == 'dependants' && dontGoInto.indexOf(node.nodeType) < 0">

										<ng-container *ngFor="let child of node.dependants">
											<ng-container
												*ngTemplateOutlet="dependencyTreeNode; context: {$implicit: child, direction: direction, dontGoInto: dontGoInto}">
											</ng-container>
										</ng-container>
									</ng-container>
								</div>
							</ng-template>

							<mat-menu #dependencyTreeMenu="matMenu">
								<ng-template matMenuContent let-node="node">
									<ng-container *ngIf="node.nodeType != 'instance'">
										<button mat-menu-item (click)="showNodeInList(node)">
											<mat-icon>link</mat-icon>
											<span>Show in list</span>
										</button>
										<button mat-menu-item (click)="gotoArtifact(node)">
											<mat-icon>edit</mat-icon>
											<span>Edit item</span>
										</button>
									</ng-container>
									<ng-container  *ngIf="node.nodeType == 'instance'">
										<button mat-menu-item (click)="showNodeInList(node, 'instance')">
											<mat-icon>link</mat-icon>
											<span>Show in instance list</span>
										</button>
										<button mat-menu-item (click)="gotoArtifact(node, 'instance')">
											<mat-icon>edit</mat-icon>
											<span>Edit instance</span>
										</button>
										<button mat-menu-item (click)="showNodeInList(node, 'deployments')">
											<mat-icon>link</mat-icon>
											<span>Show in deployment list</span>
										</button>
										<button mat-menu-item (click)="gotoArtifact(node, 'deployments')">
											<mat-icon>edit</mat-icon>
											<span>Edit deployment</span>
										</button>
									</ng-container>
								</ng-template>
							</mat-menu>

							<!--

								class DependencyNode {
					2				referenceId: string = "1234-5678-1234-5678";
									artifactType: string = "DeviceType";
									displayName: string = "My beautiful device type";
									versionString: string = "latest";
									dependencies: DependencyNode[];
									dependants: DependencyNode[];
								}
							-->

							<div *ngIf="isDependencyTreeSidebarCollapsed">
								<span class="rotated">
									<b>Dependency Tree for [SELECTED DEVICE TYPE]</b>

								</span>
							</div>

						</mat-nav-list>
					</div>
				</mat-sidenav>
				<mat-sidenav-content class="flex-direction-column">
					<div class="page-content flex">
						<as-split direction="vertical" [useTransition]="true" class="flex">
							<as-split-area [size]="globalSrv.splitTop" class="flex">
								<router-outlet></router-outlet>
							</as-split-area>
							<as-split-area [size]="globalSrv.splitBottom.size"
								[visible]="globalSrv.splitBottom.visible">
								<compile-artifact-results></compile-artifact-results>
							</as-split-area>
						</as-split>
					</div>
				</mat-sidenav-content>
			</mat-sidenav-container>
		</div>

		<div *ngIf="authSrv.licenseWarning"
			class="license-warning-wrapper license-warning-{{ authSrv.license.licenseActivationData.licenseType | lowercase }}">
			<ng-container *ngIf="authSrv.licenseWarning && !authSrv.expirationWarning && !authSrv.nolicense"> USING A {{
				authSrv.license.licenseActivationData.licenseType }} LICENSE </ng-container>
			<ng-container *ngIf="authSrv.expirationWarning && !authSrv.nolicense"> LICENSE WILL EXPIRE IN {{
				authSrv.expirationCounter }} DAYS </ng-container>
			<ng-container *ngIf="authSrv.nolicense"> YOU DO NOT HAVE AN ACTIVE LICENSE </ng-container>
		</div>

		<mat-menu #menu="matMenu" style="min-width: 10%" class="userMenu" id="user_menu_wrapper">
			<mat-card appearance="outlined" (click)="$event.stopPropagation()">
				<mat-card-content class="flex-direction-column flex">
					<div class="flex-auto flex-align-center">
						<img src="../assets/profile-picture.png" style="width: 200px; height: auto" />
					</div>
					<div class="flex flex-align-center">
						Hi,&nbsp;<span>{{ authSrv.userData.firstName }}</span>&nbsp;<span>{{ authSrv.userData.lastName
							}}</span>!
					</div>

					<div style="margin-top: 15px">
						<div class="flex-direction-column" *ngFor="let item of userMenuItems">
							<!-- {{item.title}}:"'display': {{item.display ? 'block' : 'none'}}" -->
							<button style="display: flex; flex-direction: row"
								[ngStyle]="{display: item.display ? 'flex' : 'none'}" *ngIf="item.children"
								mat-menu-item id="{{ item.id }}" [matMenuTriggerFor]="submenu"
								(click)="execute(item, $event)">
								<mat-icon *ngIf="!item.svgIcon">{{ item.icon }}</mat-icon>
								<mat-icon *ngIf="item.svgIcon" [svgIcon]="item.icon"></mat-icon>
								<span class="mat-typography">{{ item.title | translate }}</span>
							</button>

							<button style="display: flex; flex-direction: row" *ngIf="!item.children" mat-menu-item
								id="{{ item.id }}" [ngStyle]="{display: item.display ? 'flex' : 'none'}"
								(click)="execute(item)">
								<mat-icon *ngIf="!item.svgIcon">{{ item.icon }}</mat-icon>
								<mat-icon *ngIf="item.svgIcon" [svgIcon]="item.icon"></mat-icon>
								<span class="mat-typography">{{ item.title | translate }}</span>
							</button>

							<mat-divider></mat-divider>

							<mat-menu #submenu="matMenu" class="user_submenu">
								<div class="flex-direction-column" *ngFor="let subitem of userSubmenus[item.id]">
									<button class="flex-direction-row" mat-menu-item id="{{ subitem.id }}"
										[ngStyle]="{display: subitem.display ? 'block' : 'none'}"
										(click)="execute(subitem)" *ngIf="subitem.display">
										<mat-icon *ngIf="!subitem.svgIcon">{{ subitem.icon }}</mat-icon>
										<mat-icon *ngIf="subitem.svgIcon" [svgIcon]="subitem.icon"></mat-icon>
										<span class="mat-typography">{{ subitem.title | translate }}</span>
									</button>
									<mat-divider></mat-divider>
								</div>
							</mat-menu>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</mat-menu>

		<mat-menu #notificationsMenu="matMenu" style="min-width: 10%" class="notificationsMenu"
			id="notifications_menu_wrapper">
			<mat-card appearance="outlined" (click)="$event.stopPropagation()">
				<mat-card-content class="flex-direction-column flex" style="width: 100%">
					<button mat-menu-item (click)="gotoNotification(null)">
						<mat-icon color="warn">list</mat-icon>
						View All Notifications
					</button>
					<ng-container *ngFor="let notification of non_read_notifications | limit: 10">
						<button mat-menu-item (click)="gotoNotification(notification)"
							style="display: flex; flex-direction: row; align-items: center">
							<mat-icon color="warn">error</mat-icon>
							<div style="overflow: hidden">
								<div class="mat-typography">{{ notification.eventType }}
									<span *ngIf="notification.occurrenceCount > 1" style="opacity: 0.7; font-size: 0.85em"> (×{{ notification.occurrenceCount }})</span>
								</div>
								<div style="overflow: hidden; text-overflow: ellipsis">
									<div
										style="white-space: nowrap; font-size: 0.8em; opacity: 0.6; text-overflow: ellipsis; overflow: hidden">
										{{ notification.message }}</div>
								</div>
								<div style="font-size: 0.8em">{{ notification.eventTime.fromNow() }}</div>
							</div>
							<span class="flex-auto"></span>
							<button (click)="dismissNotification($event, notification)" mat-icon-button color="accent"
								class="small_text_button"><mat-icon>mark_email_unread</mat-icon></button>
						</button>
					</ng-container>
					<button *ngIf="non_read_notifications.length > 10" mat-menu-item (click)="gotoNotification(null)"
						style="display: flex; flex-direction: row; align-items: center">
						<div>&nbsp;...&nbsp;&nbsp;</div>
						<div style="overflow: hidden" class="flex-auto">
							<div class="mat-typography">{{ non_read_notifications.length - 10 }} more</div>
						</div>
					</button>
				</mat-card-content>
			</mat-card>
		</mat-menu>
	</div>
</block-ui>